// extracted by mini-css-extract-plugin
export default {"otpInput":"otp-input_otpInput__OvGtQ","digit":"otp-input_digit__wLqfl"};